const base = {
	white: '#FFFFFF',
	black: '#212121',

	gray: '#808080',
	grey: '#808080',
	grey2: '#9e9e9e',
	grey3: '#616161',
	warmGray: '#CDCDCD',
	lightGrey: '#E0E0E0',
	lightGrey2: '#EEEEEE',
	lighterGrey: '#F0F0F0',
	lighterGrey2: '#F5F5F5',
	lighterGrey3: '#fafafa',
	darkGrey: '#212121',

	red: '#E32F41',
	lightRed: '#FDEDEF',
	green: '#16BE96',
	lightGreen: '#E0F4F0',
	darkDreen: '#00A080',
	darkGreen2: '#00563E',
	blue: '#3447F4',
	lightBlue: '#EBF0FF',
	brightBlue: '#433CE6',

	coral: '#FF8C78',
	lightCoral: '#FFF1EE',
	darkCoral: '#EB6F5A',
}

const code = {
	shark: '#232628',
	alabaster: '#FCFCFC',
	whiteIce: '#E0FAEE',
	pattensBlue: '#D9E6FF',
}

const ui = {
	background: '#F6F6F6',
	heading: base.black,
	text: base.black,
	sectionBorder: base.warmGray,
	previewBorder: base.warmGray,
	stepBorder: base.warmGray,
}

const named = {
	// Branding
	colorPrimerCoral: base.coral,

	// Mains
	colorDark: base.black,
	colorBackground: ui.background,
	colorInteraction: '#3374FF',
	colorInteractionHover: '#0038AE',
	colorInteractionHoverBackground: 'rgba(0, 56, 174, 0.02)', // #0038AE at 2% opacity

	// Grays
	colorLabelIco: base.grey,
	colorPlaceholder: '#dbdbdb',

	// Sentiments
	// Fg - foreground
	// Bg - background
	// Mg - middle-ground - used in charts or in other special circumstances
	colorPositiveFg: '#008D71',
	colorPositiveMg: '#00B490',
	colorPositiveBg: '#E0FAEE',

	colorNegativeFg: '#E32F41',
	colorNegativeMg: '#E94353',
	colorNegativeBg: '#FCEDEC',

	colorAttentiveFg: '#D78203',
	colorAttentiveMg: '#FD9800',
	colorAttentiveBg: '#FFF6DD',

	colorImportantFg: '#0038FF',
	colorImportantMg: '#3447F4',
	colorImportantBg: '#D9E6FF',

	colorNeutralFg: '#808080',
	colorNeutralMg: '#DBDBDB',
	colorNeutralBg: '#F0F0F0',
}

const light = {
	...base,
	...ui,
	...named,
	...code,
}

const colors = { light }

export default colors
